import { render } from "./LabelMultiSelect.vue?vue&type=template&id=716e730c&scoped=true"
import script from "./LabelMultiSelect.vue?vue&type=script&lang=js"
export * from "./LabelMultiSelect.vue?vue&type=script&lang=js"

import "./LabelMultiSelect.vue?vue&type=style&index=0&id=716e730c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-716e730c"]])

export default __exports__